module.exports = __webpack_public_path__ + "static/media/3.41bf3241.jpeg";